import { createContext, useEffect } from 'react'

import {
  useHandleMessageEdited,
  useHandleMessageReceived,
} from '@tribeplatform/react-sdk/hooks'

import {
  MsgEditedEvent,
  MsgReceivedEvent,
  ReconnectEvent,
} from '../Socket/constants.js'
import { useSocket } from '../Socket/SocketProvider.js'

const ChatMessageContext = createContext(null)

export const ChatMessagesProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { socket } = useSocket()
  const { handleMsgReceived, handleReconnect } = useHandleMessageReceived()
  const { handleMessageEdited } = useHandleMessageEdited()

  useEffect(() => {
    socket.on(MsgReceivedEvent, handleMsgReceived)
    socket.on(MsgEditedEvent, handleMessageEdited)
    socket.io.on(ReconnectEvent, handleReconnect)
    return () => {
      socket.off(MsgReceivedEvent, handleMsgReceived)
      socket.off(MsgEditedEvent, handleMessageEdited)
      socket.io.off(ReconnectEvent, handleReconnect)
    }
  }, [handleMsgReceived, handleMessageEdited, handleReconnect, socket])

  return (
    <ChatMessageContext.Provider value={null}>
      {children}
    </ChatMessageContext.Provider>
  )
}
